import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import VueSweetalert2 from 'vue-sweetalert2';
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import VueCryptojs from 'vue-cryptojs'

import "../src/design/app.scss";
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

import "./utils";
import store from '@/state/store'

import App from './App.vue'

// import VueToast from 'vue-toast-notification';
// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
// import 'vue-toast-notification/dist/theme-sugar.css';

import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

import Vuetify from 'vuetify/lib'
// import 'vuetify/dist/vuetify.min.css'
const vuetify = new Vuetify({  })

import VueClipboard from 'vue-clipboard2'
import VueProgressBar from 'vue-progressbar'


// custom css
import "../src/assets/css/custom.css";
import "./constant";


// Get the git hash from environment variable
const gitHash = process.env.VUE_APP_GIT_HASH;

// Store in localStorage
if (gitHash) {
  localStorage.setItem("app_version", gitHash);
}


if (process.env.NODE_ENV != 'production') {
  // eslint-disable-next-line no-unused-vars
  console.log('%c' + process.env.NODE_ENV?.toUpperCase() + ' MODE', 'color: red; -webkit-text-stroke: 2px black; font-size: 50px; font-weight: bold;');
}
else {
  // eslint-disable-next-line no-unused-vars
  console.log('%c' + process.env.NODE_ENV?.toUpperCase() + ' MODE. STOP!!!', 'color: red; -webkit-text-stroke: 2px black; font-size: 50px; font-weight: bold;');
  
  // eslint-disable-next-line no-unused-vars
  console.warn('Warning: console.log has been disabled in production mode.');

  // eslint-disable-next-line no-unused-vars
  console.log = (args) => void(0);
}


Vue.use(VueRouter);
Vue.use(vco);
Vue.config.productionTip = false;

Vue.use(Vuetify);
Vue.use(BootstrapVue);

Vue.use(Vuelidate);
Vue.use(VueSweetalert2);

// Vue.use(VueToast, {
//   duration: 5000,
//   position: 'top-right',
// });

Vue.use(Toast, {
  position: "top-right",
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: false,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false
});

Vue.use(VueViewer)
Vue.use(VueCryptojs)

VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

const options = {
  color: '#ffc107',
  failedColor: '#874b4b',
  thickness: '2px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false,
  autoFinish: false,
}
 
Vue.use(VueProgressBar, options)


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#dmas-app')
